import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { CardTotalType, DashboardQuery } from "../typings";

export function useTotalReceitas(params: DashboardQuery) {
  return useQuery<CardTotalType, AxiosError>(
    `/v1/dashboards/principal/total-receitas-${params.dataFim}-${params.dataInicio}-${params.updatedAt}`,
    async () => {
      const { data } = await http.get<CardTotalType>(
        "/v1/dashboards/principal/total-receitas",
        {
          params,
        }
      );

      return data;
    }
  );
}
